import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

const normalizeToDateString = (value) => {
  if (!value) return '';
  const candidate = dayjs(value);
  return candidate.isValid() ? candidate.format('YYYY-MM-DD') : '';
};

const HTMLDatepicker = ({
  id,
  name,
  label,
  defaultValue,
  onChange,
  disabled,
  clearable,
  error,
}) => {
  const [date, setDate] = useState('');
  // Initialize / update from outside
  useEffect(() => {
    setDate(normalizeToDateString(defaultValue));
  }, [defaultValue]);

  const handleChange = (e) => {
    const raw = e.target.value || '';
    setDate(raw);

    if (!raw) {
      onChange(null);
      return;
    }

    // Notify parent only when valid
    const candidate = dayjs(raw, 'YYYY-MM-DD', true);
    onChange(candidate.isValid() ? candidate.format('YYYY-MM-DD') : null);
  };

  const handleClear = () => {
    setDate('');
    onChange(null);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {label && (
        <label
          htmlFor={id}
          style={{
            fontSize: '0.85rem',
            fontWeight: 500,
            color: disabled ? '#888' : '#333',
          }}
        >
          {label}
        </label>
      )}

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: disabled ? '#f5f5f5' : 'white',
          border: `1px solid ${error ? '#d32f2f' : '#ccc'}`,
          borderRadius: '6px',
          padding: '0 4px',
          boxShadow: error
            ? '0 0 0 1px rgba(211,47,47,0.3)'
            : '0 1px 2px rgba(0,0,0,0.1)',
          transition: 'all 0.2s ease',
          width: '140px',
        }}
      >
        <input
          id={id}
          name={name}
          type="date"
          value={date}
          onChange={handleChange}
          disabled={disabled}
          style={{
            flex: 1,
            padding: '4px 0px',
            fontSize: '0.8rem',
            border: 'none',
            outline: 'none',
            background: 'transparent',
            color: disabled ? '#888' : '#000',
            cursor: disabled ? 'not-allowed' : 'pointer',
          }}
        />

        {clearable && !disabled && date && (
          <button
            type="button"
            onClick={handleClear}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              color: '#888',
              fontSize: '0.8rem',
              padding: '0px 4px',
            }}
            title="Clear date"
          >
            ✕
          </button>
        )}
      </div>

      {error && (
        <span
          style={{
            color: '#d32f2f',
            fontSize: '0.75rem',
            marginTop: '-2px',
          }}
        >
          {error}
        </span>
      )}
    </div>
  );
};

HTMLDatepicker.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  defaultValue: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  clearable: PropTypes.bool,
  error: PropTypes.string,
};

HTMLDatepicker.defaultProps = {
  label: '',
  defaultValue: null,
  disabled: false,
  clearable: false,
  error: '',
};

export default HTMLDatepicker;
